;(function (angular, _) {
  'use strict'
  angular.module('kilo.common.directives')
    .directive('customMention', CustomMentionDirective)

  CustomMentionDirective.$inject = [
    // Angular
    // Libs
    // Managers
    'UserManager'
    // Services
    // Const
    // Resolved
  ]
  function CustomMentionDirective (
    // Angular
    // Libs
    // Managers
    UserManager
    // Services
    // Const
    // Resolved
  ) {
    return {
      require: 'mentionContainer',
      link: function ($scope, $element, $attrs, mentionContainer) {
        // Format in text area
        mentionContainer.label = function (choice) {
          return choice.label
        }

        // Search element
        mentionContainer.findChoices = function (match, mentions) {
          return UserManager.get(UserManager.query().search(match[1]))
            .then(function (data) {
              var users = _.map(data.data, function (user) {
                return {id: user._id, label: user.fullname, type: 'User'}
              })
              var usedIds = _.map(mentions, 'id')
              return _.filter(users, function (user) {
                return !_.includes(usedIds, user.id)
              })
            })
        }
      }
    }
  }

  CustomMentionController.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]
  function CustomMentionController (
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    var self = this

    _.extend(self, {
      // Public Attributes
      // Public Methods
    })
  }

})(window.angular, window._)
